import { PluginType } from '@deephaven/plugin';
import LinkerPlugin from "./LinkerPlugin.js";
var LinkerPluginConfig = {
  name: 'LinkerPlugin',
  type: PluginType.DASHBOARD_PLUGIN,
  component: LinkerPlugin
};
export default LinkerPluginConfig;
//# sourceMappingURL=LinkerPluginConfig.js.map